(() => {
  const body = document.body;
  const root = document.documentElement;
  const context = window.shBrandContext;
  if (!context) return;

  const isCart = root.dataset.shPage === 'cart';
  const isNaturalisticHome = root.dataset.shPage === 'index';
  const isSaltHome = root.dataset.shSaltHome === 'true';
  const validBrand = (value) => ['naturalistic', 'salt_house'].includes(value) ? value : null;

  const brandHomeUrl = (brand, anchor) => {
    const base = brand === 'salt_house'
      ? root.dataset.shSaltHouseUrl
      : root.dataset.shNaturalisticUrl;
    const url = new URL(base || root.dataset.shRootUrl || '/', window.location.origin);
    if (anchor) url.hash = anchor;
    return url;
  };

  const draftHomeUrl = (brand, anchor) => {
    const base = brand === 'salt_house'
      ? root.dataset.shSaltHousePreviewUrl || root.dataset.shSaltHouseUrl
      : root.dataset.shRootUrl || '/';
    const url = new URL(base, window.location.origin);
    url.searchParams.set('preview_theme_id', root.dataset.shThemeId);
    url.searchParams.set('sh_brand', brand);
    url.searchParams.set('brand_welcome', 'selected');
    if (anchor) url.hash = anchor;
    return url;
  };

  const destinationFor = (brand, anchor) => context.isDraft
    ? draftHomeUrl(brand, anchor)
    : brandHomeUrl(brand, anchor);

  const prepareBrandLink = (link, brand) => {
    if (!validBrand(brand)) return;
    link.href = destinationFor(brand, link.dataset.shBrandAnchor).href;
  };

  const prepareFamilyHomeLink = (link, brand) => {
    const name = brand === 'salt_house' ? 'Soap & Salt House' : 'Naturalistic Body Care';
    link.href = destinationFor(brand).href;
    link.setAttribute('aria-label', 'The Naturalistic Family - ' + name + ' home');
  };

  const cartPath = new URL(root.dataset.shCartUrl || '/cart', window.location.origin).pathname;
  const prepareCartLink = (link) => {
    if (link.getAttribute('href')?.startsWith('#')) return;
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }
    if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== cartPath.replace(/\/$/, '')) return;
    url.searchParams.set('sh_brand', root.dataset.shBrand);
    if (context.isDraft) url.searchParams.set('preview_theme_id', root.dataset.shThemeId);
    link.href = url.href;
  };

  const preparePreviewPolicyLink = (link) => {
    if (!context.isDraft) return;
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('preview_theme_id', root.dataset.shThemeId);
    url.searchParams.set('sh_brand', root.dataset.shBrand);
    url.searchParams.set('brand_welcome', 'selected');
    link.href = url.href;
  };

  const updateInterface = (brand) => {
    document.querySelectorAll('.skip-to-content-link').forEach((link) => {
      link.setAttribute('href', isSaltHome ? '#sh-hero-title' : '#MainContent');
    });
    body.classList.toggle('sh-salt-home', isSaltHome);
    if (isCart) document.title = brand === 'salt_house' ? body.dataset.shSaltTitle : body.dataset.shNaturalisticTitle;

    document.querySelectorAll('[data-sh-family-home]').forEach((link) => prepareFamilyHomeLink(link, brand));
    document.querySelectorAll('.sh-brand-switcher [data-sh-brand-target]').forEach((link) => {
      const active = link.dataset.shBrandTarget === brand;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-sh-brand-target]').forEach((link) => {
      prepareBrandLink(link, link.dataset.shBrandTarget);
    });
    document.querySelectorAll('[data-sh-preview-policy]').forEach(preparePreviewPolicyLink);
    document.querySelectorAll('a[href]').forEach(prepareCartLink);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.dataset.shPreviewPolicy !== undefined) preparePreviewPolicyLink(link);
    prepareCartLink(link);

    const isFamilyHome = link.dataset.shFamilyHome !== undefined;
    const brand = isFamilyHome ? root.dataset.shBrand : validBrand(link.dataset.shBrandTarget);
    if (!brand) return;
    if (isFamilyHome) prepareFamilyHomeLink(link, brand);
    else prepareBrandLink(link, brand);
    context.remember(brand);
  }, true);

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    if (isCart) context.select(context.resolve());
    updateInterface(root.dataset.shBrand);
  });

  // Preserve old draft review links, but move them onto real page-based previews.
  const legacyBrand = context.isDraft ? context.hashBrand() : null;
  const requestedBrand = context.isDraft
    ? validBrand(new URLSearchParams(window.location.search).get('sh_brand'))
    : null;
  if (isNaturalisticHome && (legacyBrand === 'salt_house' || requestedBrand === 'salt_house')) {
    window.location.assign(draftHomeUrl('salt_house').href);
    return;
  }
  if (isSaltHome && (legacyBrand === 'naturalistic' || requestedBrand === 'naturalistic')) {
    window.location.assign(draftHomeUrl('naturalistic').href);
    return;
  }

  updateInterface(root.dataset.shBrand);
})();
